import { Grid, Paper, Typography, Button } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CustomActionBar from '../../../components/CustomActionBarDatePicker';
import dayjs from 'dayjs';
import useStyles from '../styles'

const StockControlFilters = ({ filters, setFilters, clearFilters }) => {
    const { classes } = useStyles();

    const handleFilterChange = (event) =>
        setFilters({
            ...filters,
            [event.target.name]: event.target.value
        });

    return (
        <Paper className={classes.paper} style={{ marginTop: '20px' }}>
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        md: 4
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por fecha: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <DatePicker
                                label={filters?.from ? 'Desde' : 'dd/mm/aaaa'}
                                value={filters?.from ? dayjs(filters.from) : null}
                                onChange={(newValue) => {
                                    handleFilterChange({
                                        target: {
                                            name: 'from',
                                            value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
                                        }
                                    });
                                }}
                                format="DD/MM/YYYY"
                                slots={{
                                    actionBar: CustomActionBar,
                                }}
                                slotProps={{
                                    actionBar: {
                                        onChange: (newValue) => {
                                            handleFilterChange({
                                                target: {
                                                    name: 'from',
                                                    value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                                                },
                                            });
                                        },
                                        setOpen: (value) => {
                                            const picker = document.querySelector('[role="dialog"]');
                                            if (picker) picker.style.display = value ? 'block' : 'none';
                                        },
                                    },
                                    textField: {
                                        fullWidth: true,
                                        size: 'small',
                                    },
                                }}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <DatePicker
                                label={filters?.to ? 'Hasta' : 'dd/mm/aaaa'}
                                value={filters?.to ? dayjs(filters.to) : null}
                                onChange={(newValue) => {
                                    handleFilterChange({
                                        target: {
                                            name: 'to',
                                            value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
                                        }
                                    });
                                }}
                                format="DD/MM/YYYY"
                                slots={{
                                    actionBar: CustomActionBar,
                                }}
                                slotProps={{
                                    actionBar: {
                                        onChange: (newValue) => {
                                            handleFilterChange({
                                                target: {
                                                    name: 'to',
                                                    value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : '',
                                                },
                                            });
                                        },
                                        setOpen: (value) => {
                                            const picker = document.querySelector('[role="dialog"]');
                                            if (picker) picker.style.display = value ? 'block' : 'none';
                                        },
                                    },
                                    textField: {
                                        fullWidth: true,
                                        size: 'small',
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    className={classes.rootFab}
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 8
                    }}
                >
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={clearFilters}
                        className={classes.button}
                        startIcon={<FilterListIcon />}
                    >
                        Limpiar
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default StockControlFilters;